import { useCallback, useState, useEffect } from "react";
import gsap from "gsap";

export const wrap = (min, max, v) => {
  const range = max - min;
  return ((((v - min) % range) + range) % range) + min;
};

export default count => {
  const [index, setIndex] = useState(0);

  const handleKeyDown = useCallback(
    ({ keyCode }) => {
      if (!gsap.getById("slider")) {
        setIndex(state => (state + 1) % count);
      }
    },
    [count]
  );

  useEffect(() => {
    window.addEventListener("mousedown", handleKeyDown);
    window.addEventListener("touchstart", handleKeyDown);

    return () => {
      window.removeEventListener("mousedown", handleKeyDown);
      window.removeEventListener("touchstart", handleKeyDown);
    };
  }, [handleKeyDown]);

  return index;
};
